import React from 'react';
import styles from './UserPostCard.module.scss';

const UserPostCard = ({ type, avatar, name }) => {
  const renderTitle = () => {
    switch (type) {
      case 'expert':
        return 'Welcome to the Global Community of Sustainability Experts';
      case 'investor':
        // eslint-disable-next-line no-multi-str
        return 'Welcome to the Global Community of Impact Investors';
      case 'business':
        // eslint-disable-next-line no-multi-str
        return 'Welcome to the Global Community of Sustainable Businesses';
      case 'individual':
        // eslint-disable-next-line no-multi-str
        return 'Welcome to the Global Community of like-minded people';
      default:
        return '';
    }
  };

  return (
    <div className={styles.container}>
      {type === 'expert' || type === 'investor' ? (
        <img
          className={styles.backgroundImage}
          src="/images/user-post-expert.png"
          alt="post-background"
        />
      ) : type === 'business' ? (
        <img
          className={styles.backgroundImage}
          src="/images/user-post-business.png"
          alt="post-background"
        />
      ) : type === 'individual' ? (
        <img
          className={styles.backgroundImage}
          src="/images/user-post-individual.png"
          alt="post-background"
        />
      ) : null}
      {avatar ? (
        <img className={styles.avatar} src={avatar} alt="avatar" />
      ) : (
        <img className={styles.avatar} src="/images/expert-post-avatar.png" alt="avatar" />
      )}
      <div className={styles.titleBlock}>
        <p className={styles.title}>{renderTitle()}</p>
      </div>
      <p className={styles.name}>{name}</p>
    </div>
  );
};

export default UserPostCard;
